import { useState, useEffect, useRef } from 'react'

const useWindowSize = () => {
	const [windowSize, setWindowSize] = useState({ height: window.innerHeight, width: window.innerWidth })

	useEffect(() => {
		const handleResize = () => {
			setWindowSize({ height: window.innerHeight, width: window.innerWidth })
		}
		window.addEventListener('resize', handleResize)
	}, [])

	return windowSize
}

export default useWindowSize
